export enum CATEGORIES {
  ACTIVITY_LIFE = 15,
  ACTIVITY_SPORT = 16,
  FREQUENCY = 44,
  INGREDIENTS = 51,
  COUNTRY = 104,
  CITY = 105,
  SUPPLEMENT = 157,
}